module.exports = __webpack_public_path__ + "img/icon-voice-assistant-select.e072fbe8.svg";